import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    checkedKeys: [],
}

export const ModalFormItemSlice = createSlice({
    name: 'ModalFormItemSlice',
    initialState,
    reducers: {
        addCheckedKeysAction: (state, action) => {
            state.checkedKeys = action.payload
        },
    },
    extraReducers: {},
})
